<template>
    <div :class="{'my-alert-border':true,center:(type==='center'),end:(type==='end')}">
        <div class="my-alert" :style="{opacity:thisOpacity}">{{message}}</div>
    </div>
</template>
<script>
export default {
    name:'jlkj-popup',
    props:{
        message:{
            type:String,
            default:''
        },
        type:{
            type:String
        },
        // show:{
        //     type:Boolean,
        //     default:false
        // }

    },
    data(){
        return {
            thisOpacity:1,
            thisShow:this.show,
        }
    },
    watch:{
        // thisShow(val,oldVal){
        //     if(val){
        //         console.log("好戏开始")
        //         this.readyHide()
        //     }
        // }
    },
    mounted(){
            // if(this.thisShow){
            //     console.log("好戏开始")
            //     this.readyHide()
            // }
    },
    methods:{
        readyHide:function(func){
            console.log("is ok")
            setTimeout(()=>{
                let theSetInterval=setInterval(()=>{
                    if(this.thisOpacity<0.2){
                        func();
                        this.thisOpacity=1;
                        // this.thisShow=false;
                        console.log('关闭popup',this.thisShow);
                        clearInterval(theSetInterval);
                    }else{
                        this.thisOpacity=this.thisOpacity-0.166;
                    } 
                },166);
            },2000);
        }
    }
}
</script>
<style scoped>
    .my-alert-border{
        width:100vw;
        height: 100vh;
        position: fixed;
        left:0;
        top:0;
        z-index: 899;
        /* background-color: rgba(0,0,0,0.25); */
        pointer-events:none;
    }
    .center{
        display: flex;
        justify-content: center;
        align-items: center;
    }
    .end{
        display: flex;
        justify-content: center;
        align-items: flex-end;
    }
    .my-alert{
        padding:10px 15px;
        background: rgb(0,0,0,0.8);
        margin:50px 0;
        text-align: center;
        color:#FFFFFF;
        font-size: 14px;
        border-radius: 4px;
        
    }

</style>